export const setCredit = 'setCredit';
export const setCreditLoadingState = 'setCreditLoadingState';
export const setCreditError = 'setCreditError';
export const resetCreditError = 'resetCreditError';
